import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { get, post, put } from "../../../services/Services"; // Ojo: importá put también
import "bootstrap/dist/css/bootstrap.min.css";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint, faEdit, faTrash, faArrowRight, faArrowLeft, faSave, faArrowUp, faArrowDown, faClose, faSearch } from "@fortawesome/free-solid-svg-icons";
import { Modal, Button, Form } from "react-bootstrap";
import './PerformancesOrder.css';
import { Toast, ToastContainer } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import Table from 'react-bootstrap/Table';
import * as docx from "docx";
import { saveAs } from "file-saver";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { Document, Paragraph, TextRun, TableRow,Table as DocxTable, TableCell, WidthType, AlignmentType } from "docx";

function PerformancesOrder() {
  const location = useLocation();
  const configId = location.state?.ConfigId;
  const eventId = location.state?.eventId;
  const [successMessage, setSuccessMessage] = useState("");
  // Estados
  const [performances, setPerformances] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [scheduleDate, setScheduleDate] = useState("");
  const [selectedPerformances, setSelectedPerformances] = useState([]);
  const [scheduleId, setScheduleId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [schedulePerformances, setSchedulePerformances] = useState([]);
  const [nextScheduleOrder, setNextScheduleOrder] = useState(null);
  const [scheduleOrder, setScheduleOrder] = useState(null);
   
const [nextPerformanceOrderBase, setNextPerformanceOrderBase] = useState(null);
  const [performanceOrderBase, setPerformanceOrderBase] = useState(0);
  const [isLoadingScheduleData, setIsLoadingScheduleData] = useState(false);
  const [refreshPerformances, setRefreshPerformances] = useState(false);
  const [allPerformances, setAllPerformances] = useState([]); // <-- performances del evento entero
  const [selectedBubble, setSelectedBubble] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [pendingSchedules, setPendingSchedules] = useState([]);
  const [editingSchedule, setEditingSchedule] = useState(null);
  const updatedPerformances = selectedPerformances.map((id, index) => ({
    performanceId: id,
    performanceOrder: performanceOrderBase + index,
  }));
  
  // Agrega estos estados al inicio de tu componente PerformancesOrder
  const [showFormaModal, setShowFormaModal] = useState(false);
const [modalities, setModalities] = useState([]);
const [selectedModality, setSelectedModality] = useState('');
const [ModalityPerformances, setModalityPerformances] = useState([]);
const [loadingModality, setLoadingModality] = useState(false);
const [ModalityError, setModalityError] = useState(null);
  
const [formas, setFormas] = useState([]);
const [selectedForma, setSelectedForma] = useState('');
const [formaPerformances, setFormaPerformances] = useState([]);
const [loadingForma, setLoadingForma] = useState(false);
const [formaError, setFormaError] = useState(null);

const [consultaTipo, setConsultaTipo] = useState('modalidad'); // o 'forma'

  useEffect(() => {
  if (showFormaModal && consultaTipo === 'modalidad') {
    const fetchModalities = async () => {
      try {
        setLoadingModality(true);
        const response = await get(
          'https://ectech-software.com.ar/api/academy/modalities?page=0&size=100&order_by=name&orientation=asc'
        );
        const data = response.data;
        if (!data?.content) throw new Error('Error al procesar los datos de modalidades');
        setModalities(data.content);
        setModalityError(null);
      } catch (err) {
        setModalityError(err.message || 'Error al cargar las modalidades');
      } finally {
        setLoadingModality(false);
      }
    };

    fetchModalities();
  }
}, [showFormaModal, consultaTipo]);

useEffect(() => {
  if (showFormaModal && consultaTipo === 'forma') {
    const fetchFormas = async () => {
      try {
        setLoadingForma(true);
        const response = await get(
          'https://ectech-software.com.ar/api/academy/forms?page=0&size=50&order_by=name&orientation=asc'
        );
        const data = response.data;
        if (!data?.content) throw new Error('Error al procesar los datos de formas');
        setFormas(data.content);
        setFormaError(null);
      } catch (err) {
        setFormaError(err.message || 'Error al cargar las formas');
      } finally {
        setLoadingForma(false);
      }
    };

    fetchFormas();
  }
}, [showFormaModal, consultaTipo]);

const handleModalityChange = async (e) => {
  const modalityNombre = e.target.value;
  setSelectedModality(modalityNombre);

  if (modalityNombre && configId) {
    try {
      setLoadingModality(true);
      const response = await get(
        `https://ectech-software.com.ar/api/academy/events/${configId}/performances/awards`
      );
      const data = response.data;

      if (!Array.isArray(data)) throw new Error('Respuesta inesperada del servidor');

      const filtradas = data.filter((p) => p.modality === modalityNombre);

      setModalityPerformances(filtradas);
      setModalityError(null);
    } catch (err) {
      setModalityError(err.message || 'Error al cargar las performances');
      setModalityPerformances([]);
    } finally {
      setLoadingModality(false);
    }
  } else {
    setModalityPerformances([]);
  }
};

const handleFormaChange = async (e) => {
  const formaNombre = e.target.value;
  setSelectedForma(formaNombre);

  if (formaNombre && configId) {
    try {
      setLoadingForma(true);
      const response = await get(
        `https://ectech-software.com.ar/api/academy/events/${configId}/performances/awards`
      );
      const data = response.data;

      if (!Array.isArray(data)) throw new Error('Respuesta inesperada del servidor');

      // Ajustá según estructura, aquí se asume p.form.name
      const filtradas = data.filter((p) => p.participationForm === formaNombre);

      setFormaPerformances(filtradas);
      setFormaError(null);
    } catch (err) {
      setFormaError(err.message || 'Error al cargar las performances');
      setFormaPerformances([]);
    } finally {
      setLoadingForma(false);
    }
  } else {
    setFormaPerformances([]);
  }
};




  useEffect(() => {
    const fetchPreviousPerformanceOrder = async () => {
      if (!isEditing || !editingSchedule?.id || !schedules.length) return;
      const currentIndex = schedules.findIndex(s => s.id === editingSchedule.id);
      if (currentIndex <= 0) return; // No hay burbuja anterior
      const previousSchedule = schedules[currentIndex - 1];
      try {
        const response = await get(
          `https://ectech-software.com.ar/api/academy/event/${eventId}/schedule/${previousSchedule.id}`
        );
        if (response && Array.isArray(response.performances)) {
          const lastPerformanceOrder = response.performances.reduce(
            (max, p) => (p.performanceOrder > max ? p.performanceOrder : max),
            0
          );
          setPerformanceOrderBase(lastPerformanceOrder + 1);
        }
      } catch (error) {
        console.error("Error al obtener performanceOrder base:", error);
      }
    };

    fetchPreviousPerformanceOrder();
  }, [isEditing, editingSchedule, schedules, eventId]);
  useEffect(() => {
    if (configId && !isEditing) {
      get(`https://ectech-software.com.ar/api/academy/events/${configId}/performances`)
        .then((res) => {
          const normalized = res.data.map(p => ({
            ...p,
            school: typeof p.school === "string" ? { name: p.school } : p.school || { name: "Sin escuela" }
          }));
          setAllPerformances(normalized);
          setPerformances(normalized);
        })
        .catch((err) => console.error("Error al cargar performances:", err));
    }
  }, [configId, isEditing, refreshPerformances]);

  // Carga schedules
  const loadSchedules = () => {
    if (eventId) {
      get(`https://ectech-software.com.ar/api/academy/event/${eventId}/schedule`)
        .then((res) => setSchedules(res.data))
        .catch((err) => console.error("Error al cargar burbujas:", err));
    }
  };

  useEffect(() => {
    loadSchedules();
  }, [eventId]);


  useEffect(() => {
    if (!isEditing && eventId) {
      get(`https://ectech-software.com.ar/api/academy/event/${eventId}/schedule/order`)
        .then((res) => {
          setNextScheduleOrder(res.data.scheduleOrder + 1);
          setPerformanceOrderBase(res.data.performanceOrder + 1); // ⚠️ ESTO ES CLAVE
        })
        .catch((err) => {
          console.error("Error al obtener el orden:", err);
          alert("No se pudo obtener el orden inicial para la nueva burbuja.");
        });
    }
  }, [isEditing, eventId]);

  const fetchNextOrder = () => {
    if (!isEditing && eventId) {
      get(`https://ectech-software.com.ar/api/academy/event/${eventId}/schedule/order`)
        .then((res) => {
          setNextScheduleOrder(res.data.scheduleOrder + 1);
          setPerformanceOrderBase(res.data.performanceOrder + 1);
        })
        .catch((err) => {
          console.error("Error al obtener el orden inicial para la nueva burbuja:", err);
          alert("No se pudo obtener el orden inicial para la nueva burbuja.");
        });
    }
  };
  useEffect(() => {
    fetchNextOrder();
  }, [isEditing, eventId]);

  const handleEditSchedule = async (schedule) => {
    setIsEditing(true);
    setScheduleId(schedule.id);
    try {
      const res = await get(`https://ectech-software.com.ar/api/academy/event/${eventId}/schedule/${schedule.id}`);
      const data = res.data;
      setScheduleDate(data.scheduleDate || "");
      const orderedPerformances = (data.performances || []).slice().sort((a, b) => a.performanceOrder - b.performanceOrder);
      setPerformances(orderedPerformances);
      setSelectedPerformances(orderedPerformances.map((p) => Number(p.id)));
      setScheduleOrder(data.order);
      setSelectedBubble(schedule);
      setShowModal(true);
      // Buscar la burbuja anterior en schedules
      const previousOrder = data.order - 1;
      if (previousOrder >= 0 && schedules && schedules.length > 0) {
        const prevSchedule = schedules.find((s) => s.order === previousOrder);
        if (prevSchedule) {
          // Usar performances de la burbuja anterior para sacar último performanceOrder
          const lastPerfOrder = Math.max(
            ...(prevSchedule.performances || []).map((p) => p.performanceOrder),
            0
          );
          setPerformanceOrderBase(lastPerfOrder + 1);
        } else {
          setPerformanceOrderBase(0);
        }
      } else {
        setPerformanceOrderBase(0); // primera burbuja
      }
    } catch (err) {
      console.error("Error al cargar la burbuja:", err);
      alert("Error al cargar la burbuja.");
    }
  };
  // Guardar nueva burbuja o actualizar existente
  const submitSchedule = async () => {
  if (!scheduleDate) {
    alert("Por favor selecciona una fecha.");
    return;
  }

  if (selectedPerformances.length === 0) {
    alert("Selecciona al menos una performance.");
    return;
  }

  let finalScheduleOrder = scheduleOrder;
  let finalPerformanceOrderBase = performanceOrderBase;

  // 🧠 Si estamos creando una nueva burbuja
  if (!isEditing && eventId) {
    try {
      const res = await get(
        `https://ectech-software.com.ar/api/academy/event/${eventId}/schedule/order`
      );

      // Si no hay registros previos, arrancamos desde 1
      const lastScheduleOrder = res.data?.scheduleOrder ?? 0;
      const lastPerformanceOrder = res.data?.performanceOrder ?? 0;

      // 🔁 Continuar desde el último orden existente
      finalScheduleOrder = lastScheduleOrder + 1;
      finalPerformanceOrderBase = lastPerformanceOrder + 1;

      // Mostrar en pantalla el próximo orden
      setNextScheduleOrder(finalScheduleOrder);
      setNextPerformanceOrderBase(finalPerformanceOrderBase);
      setPerformanceOrderBase(finalPerformanceOrderBase);


      console.log("➡️ Próximo orden de burbuja:", finalScheduleOrder);
      console.log("➡️ Próximo orden base de performance:", finalPerformanceOrderBase);
    } catch (error) {
      console.error("Error al obtener el próximo orden:", error);
      alert("No se pudo determinar el orden de la nueva burbuja.");
      return;
    }
  }

  // 🔧 Armar payload para crear/editar burbuja
  const payload = {
    order: finalScheduleOrder,
    scheduleDate,
    performances: selectedPerformances.map((id, index) => {
      const perf = performances.find((p) => p.id === id);
      const existingOrder = perf?.performanceOrder ?? index;

      return {
        id,
        performanceOrder: isEditing
          ? existingOrder // mantiene orden previo al editar
          : finalPerformanceOrderBase + index, // suma base + index al crear
      };
    }),
  };

  // 🔁 Guardar (PUT si edita, POST si crea)
  const request = isEditing
    ? put(
        `https://ectech-software.com.ar/api/academy/event/${eventId}/schedule/${scheduleId}`,
        payload
      )
    : post(
        `https://ectech-software.com.ar/api/academy/event/${eventId}/schedule`,
        payload
      );

  request
    .then(() => {
      setShowModal(false);
      loadSchedules();
      setScheduleId(null);
      setScheduleDate("");
      setSelectedPerformances([]);
      setIsEditing(false);
      setNextScheduleOrder(null);
      setNextPerformanceOrderBase(null);
      setToastMessage("Se guardó correctamente");
      setShowToast(true);
      setTimeout(() => setSuccessMessage(""), 3000);
      setRefreshPerformances((prev) => !prev);
      fetchNextOrder();
      
    })
    .catch((err) => {
      console.error("Error al guardar la burbuja:", err);
      alert("No se pudo guardar la burbuja.");
    });
};

  // Tu función para imprimir PDF (sin cambios)
  const handlePrintPDF = async () => {
    if (!eventId) {
      alert("Falta eventId");
      return;
    }
    try {
      const response = await get(`/api/academy/events/${configId}/performances`);
      const data = response.data || response || [];
      const doc = new jsPDF();
      doc.setFontSize(18);
      doc.text("Obras Inscriptas", doc.internal.pageSize.getWidth() / 2, 20, { align: "center" });
      const columns = ["Orden General", "Orden", "Escuela", "Obra", "Forma", "Categoría"];
      const rows = data.map((item, index) => [
        index + 1,
        item.order || "",
        item.school || "",
        item.name || "",
        item.participationForm || "",
        item.category || "",
      ]);
      autoTable(doc, {
        head: [columns],
        body: rows,
        startY: 30,
        styles: { fontSize: 9 },
        headStyles: { fillColor: [41, 128, 185], halign: "center", textColor: 255 },
        alternateRowStyles: {},
        didParseCell: (data) => {
          if (data.section === "body") {
            const schoolName = data.row.raw[2];
            const hash = Array.from(schoolName).reduce((acc, char) => acc + char.charCodeAt(0), 0);
            const gray = 220 - (hash % 40);
            data.cell.styles.fillColor = [gray, gray, gray];
          }
        },
        margin: { left: 10, right: 10 },
      });
      doc.save(`Obras_Inscriptas_Evento_${eventId}.pdf`);
    } catch (error) {
      console.error("Error al obtener las obras:", error);
      alert("Ocurrió un error al generar el PDF.");
    }
  };

  const getSchoolName = (perf) => {
    if (isEditing) {
      return perf.school?.name || "Sin escuela";
    } else {
      // Cuando no es edición, perf.school puede ser string o un objeto
      if (!perf.school) return "Sin escuela";

      if (typeof perf.school === "string") {
        return perf.school;
      }
      // Si es objeto, intentamos devolver el nombre
      if (typeof perf.school === "object" && perf.school.name) {
        return perf.school.name;
      }
      return "Sin escuela";
    }
  };

  const handleAddPerformance = (id) => {
  if (selectedPerformances.includes(id)) return;

  const perf = availablePerformances.find((p) => p.id === id);
  if (!perf) return;

  // El nuevo orden empieza desde performanceOrderBase (que viene del último guardado)
  const newOrder = performanceOrderBase + selectedPerformances.length;

  const newPerf = {
    ...perf,
    performanceOrder: newOrder,
  };

  console.log("Añadiendo performance:", newPerf);
  console.log("Orden base:", performanceOrderBase);
  console.log("Index:", selectedPerformances.length + 1);

  setPerformances([...performances, newPerf]);
  setSelectedPerformances([...selectedPerformances, id]);
};



  const handleRemovePerformance = (id) => {
    setSelectedPerformances(selectedPerformances.filter((pid) => pid !== id));
  };
  const availablePerformances = allPerformances.filter(
    (p) => !selectedPerformances.includes(p.id)
  );

  const movePerformanceUp = (index) => {
    if (index === 0) return; // No hacer nada si está en la primera posición
    const newSelected = [...selectedPerformances];
    [newSelected[index - 1], newSelected[index]] = [newSelected[index], newSelected[index - 1]];
    setSelectedPerformances(newSelected);
  };
  const movePerformanceDown = (index) => {
    if (index === selectedPerformances.length - 1) return; // No hacer nada si está en la última posición
    const newSelected = [...selectedPerformances];
    [newSelected[index], newSelected[index + 1]] = [newSelected[index + 1], newSelected[index]];
    setSelectedPerformances(newSelected);
  };
  const newOrder = performanceOrderBase + selectedPerformances.length + 1;

  const getSelectedPerformancesWithOrder = () => {
  const ordered = selectedPerformances
    .map((id) => performances.find((p) => p.id === id))
    .filter(Boolean)
    .sort((a, b) => a.performanceOrder - b.performanceOrder);

  console.log('Performances ordenadas:', ordered);
  return ordered;
};


  const handlePrintPDFFinal = async () => {
    try {
      const response = await get(`/api/academy/events/${configId}/performances/awards`);
      const data = response.data || response || [];

      if (!data.length) {
        setToastMessage("No hay datos para generar el PDF.");
        setShowToast(true);
        return;
      }

      const doc = new jsPDF("p", "mm", "a4");
      let y = 5;
      const cardWidth = 200;
      const cardX = 5;
      const cardHeight = 35;
      const cardSpacing = 3;

      // Título
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.setTextColor(40, 40, 40);
      doc.text("Orden Final de Obras", 105, 10, { align: "center" });
      y += 10;

      data.forEach((award, index) => {
        if (y > 250) {
          doc.addPage();
          y = 15;
        }

        const isChoreographed = award.isChoreographed;
        const bgColor = isChoreographed ? [235, 235, 235] : [255, 255, 255];
        const textColor = [0, 0, 0];

        // Sombra
        doc.setFillColor(220, 220, 220);
        doc.roundedRect(cardX + 1, y + 1, cardWidth, cardHeight, 3, 3, "F");

        // Fondo
        doc.setFillColor(...bgColor);
        doc.roundedRect(cardX, y, cardWidth, cardHeight, 3, 3, "F");

        // Borde
        doc.setDrawColor(180, 180, 180);
        doc.roundedRect(cardX, y, cardWidth, cardHeight, 3, 3);

        // Número
        doc.setFont("helvetica", "bold");
        doc.setFontSize(22);
        doc.setTextColor(...textColor);
        doc.text(`${index + 1}`, cardX + 5, y + 12); // Subido

        const leftX = cardX + 20;
        const rightX = cardX + 120;
        let textY = y + 6; // Subido

        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.text("Modalidad:", leftX, textY);
        doc.setFont("helvetica", "normal");
        doc.text(award.modality || "", leftX + 25, textY);

        textY += 5;
        doc.setFont("helvetica", "bold");
        doc.text("Categoría:", leftX, textY);
        doc.setFont("helvetica", "normal");
        doc.text(award.category || "", leftX + 25, textY);

        textY += 5;
        doc.setFont("helvetica", "bold");
        doc.text("Forma:", leftX, textY);
        doc.setFont("helvetica", "normal");
        doc.text(award.participationForm || "", leftX + 25, textY);

        textY += 5;
        doc.setFont("helvetica", "bold");
        doc.text("Escuela:", leftX, textY);
        doc.setFont("helvetica", "normal");
        doc.text(`${award.eventRegistrationId || ""} - ${award.school || ""}`, leftX + 25, textY);
        
        textY += 5;
        doc.setFont("helvetica", "bold");
        doc.text("Obra:", leftX, textY);
        doc.setFont("helvetica", "normal");
        doc.text(award.dancePerformance || "", leftX + 25, textY);

        textY += 5;
        doc.setFont("helvetica", "bold");
        doc.text("Participantes:", leftX, textY);
        doc.setFont("helvetica", "normal");
        const participantes =
          award.participationForm?.toLowerCase() === "solista"
            ? award.members
            : `${award.countParticipants} participantes`;
        doc.text(participantes || "", leftX + 32, textY);

        // Preparadores
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("Preparadores:", rightX, y + 8);
        doc.setFont("helvetica", "normal");
        const preparersText = (award.preparers || []).join(", ");
        doc.text(doc.splitTextToSize(preparersText, 60), rightX, y + 13);

        // Coreógrafos/as
        if (isChoreographed) {
          doc.setFont("helvetica", "bold");
          doc.text("Coreógrafos/as:", rightX, y + 23);
          doc.setFont("helvetica", "normal");
          const choreographerText = (award.choreographers || []).join(", ");
          doc.text(doc.splitTextToSize(choreographerText, 60), rightX, y + 28);
        }

        // Marca "SI"
        if (isChoreographed) {
          doc.setFont("helvetica", "bold");
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(18);
          const siX = cardX + cardWidth - 25;
          const siY = y + cardHeight / 2;
          doc.text("SI", siX, siY, { align: "center" });
          doc.setTextColor(...textColor);
        }

        y += cardHeight + cardSpacing;
      });
      const pageCount = doc.getNumberOfPages();
for (let i = 1; i <= pageCount; i++) {
  doc.setPage(i);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(100);
  doc.text(`Página ${i} de ${pageCount}`, doc.internal.pageSize.getWidth() / 2, 290, { align: "center" });
}

      doc.save("orden_final.pdf");
      setToastMessage("PDF generado correctamente 🎉");
      setShowToast(true);
    } catch (error) {
      console.error("Error al generar el PDF:", error);
      setToastMessage("Error al generar el PDF.");
      setShowToast(true);
    }
  };

  const handlePrintPDFFinalbySchedule = async () => {
  try {
    // 1. Obtener datos de la API
    const response = await get(`/api/academy/events/${configId}/performances/awards`);
    const data = response.data || [];

    if (!data.length) {
      setToastMessage("No hay datos para generar el PDF.");
      setShowToast(true);
      return;
    }

    // 2. Procesar datos
    const groupedBySchedule = groupPerformancesBySchedule(data);
    const scheduleKeys = Object.keys(groupedBySchedule).sort((a, b) => a - b);

    // 3. Generar PDF
    const doc = generatePDFDocument(groupedBySchedule, scheduleKeys);

    // 4. Guardar y notificar
    doc.save("orden_finalxburbuja.pdf");
    setToastMessage("PDF generado correctamente");
    setShowToast(true);
  } catch (error) {
    console.error("Error al generar el PDF:", error);
    setToastMessage("Error al generar el PDF.");
    setShowToast(true);
  }
};

// Función auxiliar: Agrupar performances por scheduleOrder
const groupPerformancesBySchedule = (data) => {
  const grouped = {};
  data.forEach(item => {
    const key = item.scheduleOrder || "Sin orden";
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(item);
  });
  return grouped;
};

// Función auxiliar: Generar el documento PDF
const generatePDFDocument = (groupedData, scheduleKeys) => {
  const doc = new jsPDF("l", "mm", "a4");
  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;
  const cardConfig = {
    width: 280,
    x: 5,
    spacing: 2,
    baseHeight: 22,
    marginBottom: 10
  };

  scheduleKeys.forEach((scheduleOrder, i) => {
    if (i > 0) {
      doc.addPage();
    }
    
    let y = 10;
    addScheduleHeader(doc, scheduleOrder, y);
    y += 8;

    const performances = groupedData[scheduleOrder];
    performances.forEach((award, index) => {
      if (y + cardConfig.baseHeight > pageHeight - cardConfig.marginBottom) {
        doc.addPage();
        y = 10;
        addScheduleHeader(doc, scheduleOrder, y);
        y += 8;
      }

      addPerformanceCard(doc, award, index , y, cardConfig);
      y += cardConfig.baseHeight + cardConfig.spacing;
    });
  });

    // 🔢 Agregar número de página centrado en el pie de cada página
  const pageCount = doc.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(`Página ${i} de ${pageCount}`, pageWidth / 2, pageHeight - 5, { align: "center" });
  }

  return doc;
};


// Función auxiliar: Añadir encabezado de schedule
const addScheduleHeader = (doc, scheduleOrder, y) => {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(26);
  doc.setTextColor(40, 40, 40);
  doc.text(`Burbuja N° ${scheduleOrder}`, doc.internal.pageSize.width / 2, y+3, { align: "center" });
};

// Función auxiliar: Añadir tarjeta de performance
const addPerformanceCard = (doc, award, index, y, {width, x, baseHeight}) => {
  const isChoreographed = award.isChoreographed;
  
  // Dibujar sombra y fondo
  doc.setFillColor(220, 220, 220);
  doc.roundedRect(x + 1, y + 1, width, baseHeight, 3, 3, "F");
  
  doc.setFillColor(255, 255, 255);
  doc.roundedRect(x, y, width, baseHeight, 3, 3, "F");
  
  doc.setDrawColor(180, 180, 180);
  doc.roundedRect(x, y, width, baseHeight, 3, 3);

  // Número de performance
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.setTextColor(0, 0, 0);
  doc.text(`${award.performanceOrder}`, x + 5, y + 12);

  // Configuración para la primera línea (Modalidad, Categoría, Forma)
  const firstLineY = y + 5;
  const startX = x + 20;
  const labelOffset = 25;
  const fieldSpacing = 80;

  // Modalidad
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("Modalidad:", startX, firstLineY);
  doc.setFont("helvetica", "normal");
  doc.text(award.modality || "", startX + labelOffset, firstLineY);

  // Categoría
  doc.setFont("helvetica", "bold");
  doc.text("Categoría:", startX+40 + fieldSpacing, firstLineY);
  doc.setFont("helvetica", "normal");
  doc.text(award.category || "", startX+40 + fieldSpacing + labelOffset, firstLineY);

  // Forma
  doc.setFont("helvetica", "bold");
  doc.text("Forma:", startX+10 + fieldSpacing * 2, firstLineY);
  doc.setFont("helvetica", "normal");
  doc.text(award.participationForm || "", startX+10 + fieldSpacing * 2 + 15, firstLineY);

  // Resto de campos en líneas separadas
  let currentLineY = firstLineY + 5;

  // Escuela (combinando eventRegistrationId y school)
doc.setFont("helvetica", "bold");
doc.text("Escuela:", startX, currentLineY);
doc.setFont("helvetica", "normal");
doc.text(`${award.eventRegistrationId || ""} - ${award.school || ""}`, startX + labelOffset, currentLineY);
currentLineY += 5;

  

  // Obra
  doc.setFont("helvetica", "bold");
  doc.text("Obra:", startX, currentLineY);
  doc.setFont("helvetica", "normal");
  doc.text(award.dancePerformance || "", startX + labelOffset, currentLineY);
  currentLineY += 5;

  // Participantes
  doc.setFont("helvetica", "bold");
  doc.text("Participantes:", startX, currentLineY);
  doc.setFont("helvetica", "normal");
  const participantes = award.participationForm?.toLowerCase() === "solista" 
    ? award.members 
    : `${award.countParticipants} participantes`;
  doc.text(participantes || "", startX + 32, currentLineY);

  // Información derecha (Preparadores y Coreógrafos)
  const rightX = x + 180;
  
  // Preparadores
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("Preparadores:", rightX - 40, y + 10);
  doc.setFont("helvetica", "normal");
  doc.text(doc.splitTextToSize((award.preparers || []).join(", "), 80), rightX - 10, y + 10);

  // Coreógrafos (si aplica)
  if (isChoreographed) {
    doc.setFont("helvetica", "bold");
    doc.text("Coreógrafos/as:", rightX - 40, y + 15);
    doc.setFont("helvetica", "normal");
    doc.text(doc.splitTextToSize((award.choreographers || []).join(", "), 80), rightX - 10, y + 15);
    
    // Marca "SI"
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text("Coreografía", x + width - 25, y + baseHeight / 2, { align: "center" });
  }
};


const handleExportWordBySchedule = async () => {
  try {
    const response = await get(`/api/academy/events/${configId}/performances/awards`);
    const data = response.data || [];

    if (!data.length) {
      setToastMessage("No hay datos para exportar.");
      setShowToast(true);
      return;
    }

    const groupedBySchedule = groupPerformancesBySchedule(data);
    const doc = new Document({
      creator: "Sistema de Danza",
      title: "Orden de Presentaciones",
      description: "Documento generado automáticamente",
      sections: []
    });

    Object.entries(groupedBySchedule).forEach(([scheduleOrder, performances]) => {
      // Título de la burbuja
      doc.addSection({
        children: [
          new Paragraph({
            text: `Burbuja N° ${scheduleOrder}`,
            heading: "Heading1",
            alignment: AlignmentType.CENTER,
            spacing: { after: 400 },
          })
        ]
      });

      // Por cada performance
      performances.forEach((performance) => {
        const tableRows = [];

        // Fila 1: Modalidad | Categoría | Forma
        tableRows.push(
          new TableRow({
            children: [
              createLabelCell("Modalidad:"),
              createValueCell(performance.modality || "-"),
              createLabelCell("Categoría:"),
              createValueCell(performance.category || "-"),
              createLabelCell("Forma:"),
              createValueCell(performance.participationForm || "-"),
            ],
          })
        );

        // Fila 2: Escuela | Obra | Preparadores
        tableRows.push(
          new TableRow({
            children: [
              createLabelCell("Escuela:"),
              createValueCell(performance.school || "-"),
              createLabelCell("Obra:"),
              createValueCell(performance.dancePerformance || "-"),
              createLabelCell("Preparadores:"),
              createValueCell((performance.preparers || []).join(", ") || "-"),
            ],
          })
        );

        // Fila 3: Participantes (y coreógrafos si existen)
        const participantes = performance.countParticipants 
          ? `${performance.countParticipants} participantes` 
          : performance.members?.join(", ") || "-";

        const row3Cells = [
          createLabelCell("Participantes:"),
          createValueCell(participantes),
          createEmptyCell(),
          createEmptyCell()
        ];

        if (performance.choreographers?.length > 0) {
          row3Cells.push(
            createLabelCell("Coreógrafos/as:"),
            createValueCell(performance.choreographers.join(", "))
          );
        } else {
          row3Cells.push(createEmptyCell(), createEmptyCell());
        }

        tableRows.push(new TableRow({ children: row3Cells }));

        // Añadir tabla al documento
        doc.addSection({
          children: [
            new DocxTable({
              width: { size: 100, type: WidthType.PERCENTAGE },
              borders: {
                top: { style: "single", size: 4, color: "000000" },
                bottom: { style: "single", size: 4, color: "000000" },
                left: { style: "single", size: 4, color: "000000" },
                right: { style: "single", size: 4, color: "000000" },
                insideHorizontal: { style: "single", size: 4, color: "000000" },
                insideVertical: { style: "single", size: 4, color: "000000" },
              },
              rows: tableRows,
              margins: { top: 200, bottom: 200 } // Espacio entre tablas
            }),
            new Paragraph({ text: "", spacing: { after: 200 } }) // Espacio adicional
          ]
        });
      });
    });

    // Generar y descargar el documento
    const blob = await docx.Packer.toBlob(doc);
    saveAs(blob, `orden_presentaciones.docx`);

    setToastMessage("Documento Word generado correctamente");
    setShowToast(true);
  } catch (error) {
    console.error("Error al exportar Word:", error);
    setToastMessage("Error al generar el documento.");
    setShowToast(true);
  }
};

// Funciones auxiliares mejoradas
const createLabelCell = (text) => new TableCell({
  children: [new Paragraph({
    children: [new TextRun({ text, bold: true })],
    alignment: AlignmentType.LEFT
  })],
  width: { size: 15, type: WidthType.PERCENTAGE },
  margins: { left: 100, right: 100 }
});

const createValueCell = (text) => new TableCell({
  children: [new Paragraph({
    children: [new TextRun({ text })],
    alignment: AlignmentType.LEFT
  })],
  width: { size: 20, type: WidthType.PERCENTAGE },
  margins: { left: 100, right: 100 }
});

const createEmptyCell = () => new TableCell({
  children: [new Paragraph("")],
  width: { size: 10, type: WidthType.PERCENTAGE }
});

    return (
  <div className="container mt-4 small">
    {successMessage && (
      <div className="alert alert-success text-center py-2" role="alert">
        {successMessage}
      </div>
    )}

    <div className="row">
      <div className="col-md-6">
        <h5 className="text-center">Obras Disponibles</h5>
        <table className="table table-bordered table-sm fixed-header-table">
          <thead className="table-light">
            <tr>
              <th>Orden</th>
              <th>Escuela</th>
              <th>Obra</th>
              <th>Forma</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {availablePerformances.map((perf, index) => (
              <tr key={perf.id}>
                <td>{index + 1}</td>
                <td>{getSchoolName(perf)}</td>
                <td>{perf.name}</td>
                <td>{perf.participationForm}</td>
                <td>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => handleAddPerformance(perf.id)}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="col-md-6">
        <h5 className="text-center">Obras en Burbuja</h5>
        <table className="table table-bordered table-sm fixed-header-table">
          <thead className="table-light">
            <tr>
              <th>Orden</th>
              <th>Escuela</th>
              <th>Obra</th>
              <th>Forma</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {getSelectedPerformancesWithOrder().map((perf, index) => (
              <tr key={perf.id}>
                <td>{performanceOrderBase + index}</td>
                <td>{getSchoolName(perf)}</td>
                <td>{perf.name}</td>
                <td>{perf.participationForm}</td>
                <td className="d-flex gap-1">
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => movePerformanceUp(index)}
                    disabled={index === 0}
                  >
                    <FontAwesomeIcon icon={faArrowUp} />
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => movePerformanceDown(index)}
                    disabled={index === getSelectedPerformancesWithOrder().length - 1}
                  >
                    <FontAwesomeIcon icon={faArrowDown} />
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleRemovePerformance(perf.id)}
                  >
                    <FontAwesomeIcon icon={faArrowLeft} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    <div className="d-flex justify-content-center mb-3">
      <button className="btn btn-warning btn-sm mx-2" onClick={handlePrintPDF}>
        <FontAwesomeIcon icon={faPrint} /> Imprimir Obras Inscriptas
      </button>
      <button className="btn btn-danger btn-sm mx-2" onClick={handlePrintPDFFinal}>
        <FontAwesomeIcon icon={faPrint} /> Imprimir Orden Final
      </button>
      <button className="btn btn-primary btn-sm mx-2" onClick={handlePrintPDFFinalbySchedule}>
        <FontAwesomeIcon icon={faPrint} /> Imprimir Orden Final x Burbujas
      </button>
      <button className="btn btn-secondary btn-sm mx-2" onClick={() => {setConsultaTipo('modalidad'); setShowFormaModal(true); setSelectedModality('');
        setModalityPerformances([]);
        setModalityError(null);
      }}> <FontAwesomeIcon icon={faSearch} /> Consultar por Modalidad
      </button>
      <button className="btn btn-warning btn-sm mx-2" onClick={() => {setConsultaTipo('forma'); setShowFormaModal(true); setSelectedForma('');
        setFormaPerformances([]);
        setFormaError(null);
      }}> <FontAwesomeIcon icon={faSearch} /> Consultar por Forma
      </button>

            
      
    </div>

    <div className="d-flex justify-content-center align-items-center gap-3 mb-3">
      <Form.Group className="mb-0">
        <Form.Label className="mb-0 me-2">Fecha de la Burbuja:</Form.Label>
        <Form.Control
          type="date"
          size="sm"
          value={scheduleDate}
          onChange={(e) => setScheduleDate(e.target.value)}
        />
      </Form.Group>
      <Button variant="primary" size="sm" onClick={submitSchedule}>
        <FontAwesomeIcon icon={faSave} /> Guardar Burbuja
      </Button>
    </div>

    {Array.isArray(schedules) && schedules.length > 0 && (
      <div className="container mt-4">
        <div className="row">
          {schedules.map((schedule, i) => (
            <div className="col-md-4 mb-3" key={schedule.id || i}>
              <div className="card shadow-sm h-100 d-flex flex-column justify-content-between">
                <div className="card-body">
                  <h5 className="card-title text-center">Burbuja N°{schedule.order}</h5>
                  <hr className="my-4" />
                  <h6 className="card-text text-center">
                    Orden: {
  schedule.performances.length > 0
    ? `${Math.min(...schedule.performances.map(p => p.performanceOrder))} a ${Math.max(...schedule.performances.map(p => p.performanceOrder))}`
    : 'Sin obras'
}

                  </h6>
                  <p className="card-text text-center">
                    Cantidad de Obras: {schedule.performances?.length || 0}
                  </p>
                  <div className="d-flex justify-content-center mt-3 gap-2 flex-wrap">
                    <button
                      className="btn btn-sm btn-secondary"
                      onClick={() => handleEditSchedule(schedule)}
                    >
                      <FontAwesomeIcon icon={faEdit} /> Editar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}

    <ToastContainer position="bottom-end" className="p-3">
      <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={3000}
        autohide
        bg="success"
        style={{
          minWidth: "300px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          borderRadius: "0.75rem",
          border: "1px solid #198754",
        }}
      >
        <Toast.Header
          closeButton={true}
          className="text-white"
          style={{ backgroundColor: "#198754", borderBottom: "none" }}
        >
          <strong className="me-auto">Éxito</strong>
          <small>Ahora</small>
        </Toast.Header>
        <Toast.Body className="text-white" style={{ fontSize: "1rem", fontWeight: "500" }}>
          {toastMessage}
        </Toast.Body>
      </Toast>
    </ToastContainer>

   <Modal show={showFormaModal} onHide={() => setShowFormaModal(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>
      {consultaTipo === 'modalidad' ? 'Consultar Obras por Modalidad' : 'Consultar Obras por Forma'}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {(consultaTipo === 'modalidad' && ModalityError) && (
      <div className="alert alert-danger" role="alert">
        Error: {ModalityError}
      </div>
    )}
    {(consultaTipo === 'forma' && formaError) && (
      <div className="alert alert-danger" role="alert">
        Error: {formaError}
      </div>
    )}

    {consultaTipo === 'modalidad' && (
      <Form.Group controlId="modalidadSelect" className="mb-4">
        <Form.Label>Seleccione una Modalidad:</Form.Label>
        <Form.Control
          as="select"
          value={selectedModality}
          onChange={handleModalityChange}
          disabled={loadingModality || modalities.length === 0}
        >
          <option value="">
            {loadingModality ? 'Cargando modalidades...' : '-- Seleccione una modalidad --'}
          </option>
          {modalities.map((modality) => (
            <option key={modality.id} value={modality.name}>
              {modality.name}
            </option>
          ))}
        </Form.Control>
        {loadingModality && modalities.length === 0 && (
          <small className="text-muted">Cargando modalidades...</small>
        )}
      </Form.Group>
    )}

    {consultaTipo === 'forma' && (
      <Form.Group controlId="formaSelect" className="mb-4">
        <Form.Label>Seleccione una Forma:</Form.Label>
        <Form.Control
          as="select"
          value={selectedForma}
          onChange={handleFormaChange}
          disabled={loadingForma || formas.length === 0}
        >
          <option value="">
            {loadingForma ? 'Cargando formas...' : '-- Seleccione una forma --'}
          </option>
          {formas.map((forma) => (
            <option key={forma.id} value={forma.name}>
              {forma.name}
            </option>
          ))}
        </Form.Control>
        {loadingForma && formas.length === 0 && (
          <small className="text-muted">Cargando formas...</small>
        )}
      </Form.Group>
    )}

    {consultaTipo === 'modalidad' ? (
      loadingModality ? (
        <div className="text-center my-4">
          <Spinner animation="border" role="status" />
          <p>Buscando obras...</p>
        </div>
      ) : (
        <div>
          <h5>Obras encontradas: {ModalityPerformances.length}</h5>
          {/* Mapeá y mostrá aquí las performances filtradas por modalidad */}
        </div>
      )
    ) : (
      consultaTipo === 'forma' && (
        loadingForma ? (
          <div className="text-center my-4">
            <Spinner animation="border" role="status" />
            <p>Buscando obras...</p>
          </div>
        ) : (
          <div>
            <h5>Obras encontradas: {formaPerformances.length}</h5>
            {/* Mapeá y mostrá aquí las performances filtradas por forma */}
          </div>
        )
      )
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowFormaModal(false)}>
      <FontAwesomeIcon icon={faClose} /> Cerrar
    </Button>
  </Modal.Footer>
</Modal>

  </div>
);

  };
  export default PerformancesOrder;